import React, { useContext, useEffect, useRef, useState } from "react";
import { ClipLoader } from "react-spinners";
import Breadcrumb from "../Generic/Breadcrumb";
import { getPartnerDeatils, getSaluteDetails } from "../Redux/API";
import { AppContext } from "../Redux/ContextProvider";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

const Gallery = () => {

  const [filter, setFilter] = useState("");
  const [isFilterLoading, setIsFilterLoading] = useState(false);
  const { appState, dispatch } = useContext(AppContext);
  const { salute, saluteLoader } = appState;
  const myRef = useRef(null);

  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState(0);
  const [lightboxImages, setLightboxImages] = useState([]);

  useEffect(() => {
    getPartnerDeatils(appState, dispatch);
    getSaluteDetails(appState, dispatch);
  }, []);


  const getOptimizedImage = (imageUrl, width = 500, quality = 70) => {
    if (!imageUrl) return "";

    return `https://images.weserv.nl/?url=${encodeURIComponent(
      imageUrl
    )}&w=${width}&q=${quality}&output=webp`;
  };

  const getThumbnailImage = (item) => {
    const originalImage = item?.icon_image;

    if (!originalImage) return "";

    return getOptimizedImage(originalImage, 500, 70);
  };

  const getLightboxImage = (item) => {
    const originalImage =
      item?.icon_image_full || item?.icon_image;

    if (!originalImage) return "";

    return getOptimizedImage(originalImage, 1600, 80);
  };


  const years = [
    ...new Set(
      salute?.salutes_section
        ?.filter(
          (s) => s.main_title === "Gallery"
        )
        ?.flatMap((section) =>
          section.services_list.map(
            (item) =>
              item.services_sub_title
          )
        )
        ?.filter(Boolean)
    ),
  ];

  const sortedYears = [...years].sort((a, b) => b - a);


  useEffect(() => {
    if (sortedYears.length > 0 && !filter) {
      setFilter(sortedYears[0]);
    }
  }, [sortedYears, filter]);

    const handleFilterChange = (e) => {
    const newFilter = e.target.value;

    setIsFilterLoading(true);

    setFilter(newFilter);

    setTimeout(() => {
      setIsFilterLoading(false);
    }, 500);
  };


  const openLightbox = (images, index) => {
    setLightboxImages(
      images.map((item) => ({
        fullSize: getLightboxImage(item),
      }))
    );
    setLightboxIndex(index);
    setIsLightboxOpen(true);
  };

  const closeLightbox = () => {
    setIsLightboxOpen(false);
  };

    // Skeleton Cards
  const renderSkeletons = () => {
    return Array.from({ length: 6 }).map((_, index) => (
      <div
        className="col-xl-4 col-lg-4 col-md-6 col-sm-6 mt-0 mb-20"
        key={index}
      >
        <div className="portfolio-item1 mb-15">
          <div className="gallery-skeleton">
            <div className="skeleton-shimmer"></div>
          </div>
        </div>
      </div>
    ));
  };
  
  return (
    <>
      {saluteLoader ? (
          <div className='home-spinner'>
            <ClipLoader color={"#2A5350"} loading={true} size={60} />
          </div>
      ) : (
                 Object.keys(salute).length > 0 && (
          <>
            <Breadcrumb
              pageName="Gallery"
              pageTitle="Gallery"
            />
            <div ref={myRef}>
              {
                salute.salutes_section &&
                salute.salutes_section.length &&
                salute.salutes_section
                  .filter((s) => s.main_title === "Gallery")
                  .map((section, sectionIndex) => {
                    const sortedServices = section.services_list
                      .slice()
                      .sort(
                        (a, b) =>
                          Number(b.our_services_id) -
                          Number(a.our_services_id)
                      );
                    const filteredServices = sortedServices.filter((item) => {
                      return (
                        filter === "all" ||
                        item.services_sub_title === filter
                      );
                    });
                    return (
                      filteredServices.length > 0 &&
                      <div className="portfolio-section mb-50" id="project" key={sectionIndex} >
                        <div className="container">
                          <div className="gallery-filter">
                            <select
                              className="glass-effect"
                              value={filter}
                              onChange={handleFilterChange}
                            >
                              {sortedYears.map((year) => (
                                <option key={year} value={year}>
                                  {year}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="section-title2 primary3 text-start">
                            <span>{section.main_title}</span>
                            <div>
                              <h3>{section.highlist_title}</h3>
                            </div>
                            {/* <p className="para">
                                      {section.sub_title}
                                    </p> */}
                          </div>
                          <div className="row position-relative">
                           {isFilterLoading ? (
                                renderSkeletons()
                              ) : (
                                filteredServices.map(
                                (item, index) => (
                                  <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 mt-0 mb-20" key={`${item.id || "item"}-${index}`}>
                                    <div
                                      className="portfolio-item1 gallery-item1 mb-15">
                                      <div className="portfolio-img gallery-img gallry-items position-relative">
                                        {
                                          item.icon_image &&
                                          <div className="image portfolio-img">
                                             <img
                                                src={getThumbnailImage(item)}
                                                alt="portfolio-img"
                                                className="img-fluid"
                                                loading="lazy"

                                                // If weserv image fails,
                                                onError={(e) => {
                                                  if (
                                                    e.currentTarget
                                                      .src !==
                                                    item.icon_image
                                                  ) {
                                                    e.currentTarget.src =
                                                      item.icon_image;
                                                  }
                                                }}
                                              />
                                          </div>
                                        }
                                        <div
                                          className="zoom-icon"
                                          onClick={() => openLightbox(filteredServices, index)}
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="40"
                                            height="40"
                                            viewBox="0 0 24 24"
                                          >
                                            <path
                                              fill="none"
                                              stroke="currentColor"
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                              strokeWidth="2"
                                              d="m21 21l-4.343-4.343m0 0A8 8 0 1 0 5.343 5.343a8 8 0 0 0 11.314 11.314M11 8v6m-3-3h6"
                                            />
                                          </svg>
                                        </div>
                                      </div>

                                      {/* <div className="portfolio-content">
                                        <span>{section.highlist_title}</span>
                                        <h4><p>{item.title}</p></h4>
                                      </div> */}
                                    </div>
                                  </div>
                                )
                             )
                              )}
                          </div>
                        </div>
                      </div>
                    )
                  })
              }
            </div>

            {isLightboxOpen && lightboxImages.length > 0 && (
              <Lightbox
                mainSrc={lightboxImages[lightboxIndex].fullSize}
                nextSrc={
                  lightboxImages[
                    (lightboxIndex + 1) % lightboxImages.length
                  ].fullSize
                }
                prevSrc={
                  lightboxImages[
                    (lightboxIndex + lightboxImages.length - 1) %
                    lightboxImages.length
                  ].fullSize
                }
                onCloseRequest={closeLightbox}
                onMovePrevRequest={() =>
                  setLightboxIndex(
                    (lightboxIndex + lightboxImages.length - 1) %
                    lightboxImages.length
                  )
                }
                onMoveNextRequest={() =>
                  setLightboxIndex(
                    (lightboxIndex + 1) % lightboxImages.length
                  )
                }
              />
            )}
         </>
        )
      )}

      {/* Skeleton CSS */}
       <style>{`
        .gallery-skeleton {
          width: 100%;
          height: 300px;
          border-radius: 8px;
          overflow: hidden;
          position: relative;
          background: #e9e9e9;
        }

        .skeleton-shimmer {
          position: absolute;
          top: 0;
          left: -150%;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(206, 206, 206, 0.6),
            transparent
          );
          animation: skeleton-loading 1.3s infinite;
        }

        @keyframes skeleton-loading {
          0% {
            left: -150%;
          }

          100% {
            left: 150%;
          }
        }

        @media (max-width: 767px) {
          .gallery-skeleton {
            height: 250px;
          }
        }
      `}</style>
    </>
  );
};

export default Gallery;